<template>
    <div>
        <span class="text-lg">
            Tài xế đầy đủ pháp lý
        </span>
        <div class="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-8">
            <analytics-card
                :text="$t('labels.legallySufficient')"
                :value="$formatters.formatCurrency(dataAnalytics.totalLegallySufficient)"
                color="success"
                increase
                @click="getItems('legallySufficient')" />
            <analytics-card
                :text="$t('labels.approachingExpiration')"
                :value="$formatters.formatCurrency(dataAnalytics.totalApproachingExpiration)"
                color="accent"
                increase
                @click="getItems('approachingExpiration')" />
            <analytics-card
                :text="$t('labels.notlegallySufficient')"
                :value="$formatters.formatCurrency(dataAnalytics.totalNotlegallySufficient)"
                color="error"
                increase
                @click="getItems('notLegallySufficient')" />
        </div>
    </div>

    <analytics-modal
        v-model:visible="visible"
        :headers="headers"
        :loading="loading"
        :items="items" />
</template>
<script lang="ts" setup>
import AnalyticsCard from '../analytics-card.vue'
import AnalyticsModal from '../analytics-modal.vue'
import { $api, $lodash } from '#imports'

const dataAnalytics = ref<{
  totalApproachingExpiration: number
  totalLegallySufficient: number
  totalNotlegallySufficient: number
}>({
  totalApproachingExpiration: 0, // Sắp hết hạn
  totalLegallySufficient: 0, // Đầy đủ pháp lý
  totalNotlegallySufficient: 0 // Không đầy đủ pháp lý
})

onMounted(async () => {
  const api = $url.dashboard.fleetVehicleManagement.getNearingExpirationDocumentContract
  const data: any = await $api(api)
  const resData: any = $lodash.get(data, 'data.value')
  if (resData?.success) {
    dataAnalytics.value = resData.data
  }
})

const items = ref<Array<any>>([])
const store = $store()
const { $formatters } = useNuxtApp()

const loading = ref(false)
const visible = ref(false)

const getItems = async (type: string) => {
  try {
    loading.value = true
    visible.value = true
    const api = $url.dashboard.fleetVehicleManagement.getDataNearingExpirationDocumentContract
    const data: any = await $api(api, { uriParams: { TYPE: type } })
    const resData: any = $lodash.get(data, 'data.value')
    if (resData?.success) {
      items.value = resData.data
    }
    loading.value = false
  } catch (e: any) {
    loading.value = false
    visible.value = false
  }
}

// const handleViewDetail = (driver: any) => {
//   const routeData = useRouter().resolve({ name: 'trucker-id-driver-list', query: { action: 'view', idViewDetail: driver._id } })
//   window.open(routeData.href, '_blank')
// }

const headers = [
  {
    field: 'fullName',
    headerName: $t('labels.fullName'),
    resizable: true,
    sortable: true,
    minWidth: 180,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'idCardNumber',
    headerName: $t('labels.driverModule.idCardNumber'),
    resizable: true,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'phone',
    headerName: $t('labels.phone'),
    valueFormatter: (params: any) => {
      const code = params?.data?.phone.code || ''
      const phone = params?.data?.phone.phone || ''
      return code ? `(${code}) ${phone}` : phone
    }
  },
  {
    field: 'email',
    headerName: $t('labels.email'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'vehicleDetail.licensePlate',
    headerName: $t('labels.vehicleModule.licensePlate')
  },
  {
    field: 'licenseClass',
    minWidth: 180,
    headerName: $t('labels.driverModule.licenseType'),
    valueGetter: (params: any) => {
      return params.data.licenseClass
    }
  },
  {
    field: 'status',
    headerName: $t('labels.status'),
    valueFormatter: (params: any) => {
      if (params.data.status === 0) {
        return $t('labels.notReadyYet')
      }
      if (params.data.status === 1) {
        return $t('labels.conditionallyReady')
      }
      if (params.data.status === 2) {
        return $t('labels.ready')
      }
      return ''
    }
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      if (params.data.createdAt) {
        return $formatters.datetime(params.data.createdAt)
      }
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      if (params.data.updatedAt) {
        return $formatters.datetime(params.data.updatedAt)
      }
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: 'DataTableActions',
    cellRendererParams: {
      storeKey: 'dashboardDataTable',
      storeName: 'Dashboard',
      isAll: true
    }
  }
]
</script>
